import { WorkspaceEditor } from "@/components/admin/workspaces/WorkspaceEditor";

export default function WorkspaceNewPage() {
  return <WorkspaceEditor initial={null} />;
}
